import { createFileRoute } from '@tanstack/react-router';

import { AgencySettingsTab } from '@/components/agency/agency-settings-tab';
import { loadNamespaces } from '@/lib/i18n/i18n';

export const Route = createFileRoute('/_authenticated/agency/settings/')({
  loader: () => loadNamespaces('settings'),
  staticData: {
    title: 'route.agency_settings_details.title',
  },
  component: AgencySettingsTab,
});
